<template>
  <div :class="`formulate-input-element formulate-input-element--${context.type}${getDisabledClass}`"
    
    :data-type="context.type"
  >
    <!-- placeholder="DD/MM/YYYY" -->
    <FormulateInput
        type="radio"
        :name="context.name"
        :readonly="getDisabled"
        :disabled="getDisabled"
        :value="getInputValue"
        :options="context.options"
        @blur="context.blurHandler" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
        
    }
  },
  beforeMount () {
    // set to store for quote to work
    this.$store.commit('setAnswer',{
      step: this.getStep('quote'),
      answer: 'vehicle_include_under25_cover',
      value: this.getInputValue
    });
    // set value directly on input so reactive stuff works
    this.context.model = this.getInputValue;
  },
  computed: {
    ...mapGetters({ driver: 'getDriver', answers: 'flattenedAnswers', getStep: 'getStep' }),
    model () {
      return this.context.model
    },
    getDisabled() {
      if ( this.getDriverAgeOver25 ) {
        return false;
      } else {
        return true;
      }
    },
    getDisabledClass(){
      if ( this.getDriverAgeOver25 ) {
        return '';
      } else {
        this.$emit('hide-this-element');
        return ' formulate-input-element--disabled';
      }
    },
    getDriverAgeOver25() {

      if ( this.driver.dob ) {
        var twentyfiveyearsago = new Date();
        twentyfiveyearsago.setFullYear( twentyfiveyearsago.getFullYear() - 25 );

        // fiddle with the date
        var day = this.driver.dob.substring(0,2)
        var month = this.driver.dob.substring(3,5)
        var year = this.driver.dob.substring(6);

        var dob = new Date(year + '-' + month + '-' + day);

        if ( twentyfiveyearsago.getTime() >= dob.getTime() ) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    getInputValue(){
      // TODO: fix bug in here
      // Set DOB to > 25, continue, select 'No', go back and set DOB to < 25, continue.
      // Not showing `vehicle_excess_under_25_note` field

      // if ( !this.getDriverAgeOver25 ) {
      //   return 'yes'
      // }

      if ( this.answers[this.getStep('quote')].vehicle_include_under25_cover ) {
        if ( this.getDriverAgeOver25 ) {
          return this.answers[this.getStep('quote')].vehicle_include_under25_cover;
        } else {
          return 'yes'
        }
      } else {
        if ( this.getDriverAgeOver25 ) {
          return 'no'
        } else {
          return 'yes'
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .formulate-input-element--vehicledriverunder25.formulate-input-element--disabled {
    display:none;

    & ~ div {
      display:none;
    }
  }
</style>